import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Collapse,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { green } from "@mui/material/colors";

const AddPaymentLinkDialog = ({
  open,
  onClose,
  onAdd,
  errorMessage,
  setErrorMessage,
  loading,
}) => {
  const [newAppName, setNewAppName] = useState("");
  const [newLink, setNewLink] = useState("");
  const [newExpiresAt, setNewExpiresAt] = useState("");

  const handleAdd = () => {
    if (!newAppName || !newLink || !newExpiresAt) {
      alert("アプリ名、リンクと有効期限は必須です。"); // アラートを表示
      return; // 処理を中断
    }
    onAdd(newAppName, newLink, newExpiresAt);
    setNewAppName(""); // フィールドをリセット
    setNewLink(""); // フィールドをリセット
    setNewExpiresAt(""); // フィールドをリセット
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>新しい送金URLを追加</DialogTitle>
      <DialogContent>
        {errorMessage && (
          <Collapse in={Boolean(errorMessage)}>
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setErrorMessage("");
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              {errorMessage}
            </Alert>
          </Collapse>
        )}
        <FormControl fullWidth margin="dense" required>
          <InputLabel>アプリ名</InputLabel>
          <Select
            value={newAppName}
            onChange={(e) => setNewAppName(e.target.value)}
            label="アプリ名"
          >
            <MenuItem value="PayPay">PayPay</MenuItem>
            <MenuItem value="PayPal">PayPal</MenuItem>
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          label="Link"
          type="text"
          fullWidth
          value={newLink}
          onChange={(e) => setNewLink(e.target.value)}
          required
        />
        <TextField
          margin="dense"
          label="有効期限"
          type="datetime-local"
          fullWidth
          value={newExpiresAt}
          onChange={(e) => setNewExpiresAt(e.target.value)}
          required
        />
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleAdd} color="primary">追加</Button>
                <Button onClick={onClose} color="secondary">キャンセル</Button> */}

        <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
          <Button variant="contained" onClick={onClose} color="secondary">
            キャンセル
          </Button>
          <Box sx={{ position: "relative" }}>
            <Button
              variant="contained"
              onClick={handleAdd}
              disabled={loading}
              color="primary"
            >
              追加
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default AddPaymentLinkDialog;
